export default __webpack_public_path__ + "static/media/walker-silhouette-gray.5de1f5bc.svg";